module.exports = __webpack_public_path__ + "img/weather cloud.c61acf65.jpg";